import * as yup from 'yup'
import { REQUIRED_FIELD } from 'constants/errors'

export const schemaImportMassLegalFees = yup.object().shape({
  Document: yup.mixed().required('Please, upload file'),
  VendorId: yup.string().required(REQUIRED_FIELD),
  RefNumber: yup.string(),
})
